import React, { useState } from "react";

function FillDetails() {
  const [formData, setFormData] = useState({
    fullName: "",
    mobileNumber: "",
    email: "",
    location: "",
    notes: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { fullName, mobileNumber, location } = formData;

    if (!fullName || !mobileNumber || !location) {
      alert("Please fill out all required fields.");
      return;
    }

    if (mobileNumber.length !== 10 || isNaN(mobileNumber)) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }

    try {
      const response = await fetch("send_email.php", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        alert("Form submitted successfully! We will get in touch with you shortly.");
        setFormData({
          fullName: "",
          mobileNumber: "",
          email: "",
          location: "",
          notes: "",
        });
      } else {
        alert("An error occurred while submitting the form. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while submitting the form. Please try again.");
    }
  };

  return (
    <section className="fill-details">
      <div className="container">
        <div className="fill-details-contain">
          <h1 className="fade-out fade-in ">Enter Your Contact Information</h1>
          <h6 className="fade-out fade-in ">
            Please provide your contact details below so we can get in touch with you.
          </h6>
          <form id="contactForm" onSubmit={handleSubmit}>
            <input
              className="fade-out fade-in "
              type="text"
              name="fullName"
              placeholder="Full Name"
              required
              value={formData.fullName}
              onChange={handleChange}
            />
            <input
              className="fade-out fade-in "
              type="number"
              name="mobileNumber"
              placeholder="Mobile Number"
              required
              value={formData.mobileNumber}
              onChange={handleChange}
            />
            <input
              className="fade-out fade-in "
              type="email"
              name="email"
              placeholder="Email Address (Optional)"
              value={formData.email}
              onChange={handleChange}
            />
            <input
              className="fade-out fade-in "
              type="text"
              name="location"
              placeholder="Location"
              required
              value={formData.location}
              onChange={handleChange}
            />
            <textarea
              className="fade-out fade-in "
              name="notes"
              placeholder="Additional Notes (Optional)"
              value={formData.notes}
              onChange={handleChange}
            />
            <label className="fade-out fade-in ">
              *By clicking the "Book Now" button, you agree to our <a href="">Terms & Conditions</a> and{" "}
              <a href="">Privacy Policy</a>.
            </label>
            <button type="submit" className="btn-null btn-primary fade-out fade-in fade-out-right">
              Book Now <i className="fa-solid fa-angle-right"></i>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default FillDetails;
